import { getFetch } from '../fetch';
import { apiConfig } from '../config';

import { ContainerModules } from '../../../typings';

export interface GetContainerModulesQueryParams {
    courseId?: number | null;
    withLessons?: boolean;
}

export function getContainerModules(
    containerSlug: string,
    queryParams: GetContainerModulesQueryParams
): Promise<ContainerModules> {
    const { apiGetContainerModules } = apiConfig.getStaticUrls();
    const { courseId, withLessons } = queryParams;

    return getFetch(`${apiGetContainerModules}${containerSlug}/`, {
        course_id: courseId ?? undefined,
        lesson_groups: withLessons,
    });
}
